import {ChangeDetectionStrategy, Component, input} from '@angular/core';
import {FormControl, ReactiveFormsModule} from '@angular/forms';
import {InputTextGroupComponent} from '@brunata-angular/ui';
import {TranslatePipe} from '@brunata-angular/util';
import {StepCardDirective} from '../step-card/step-card.directive';
import {stepLabels} from '../step-card/step-labels.model';
import {maxSavedExportNameLength} from '../../saved-exports/saved-export.model';

@Component({
    selector: 'app-name-step',
    standalone: true,
    providers: [
        stepLabels(
            'customizedexports_export_step_name_title',
            'customizedexports_export_step_name_hint',
        ),
    ],
    hostDirectives: [{directive: StepCardDirective, inputs: ['titleKey', 'hintKey']}],
    imports: [ReactiveFormsModule, InputTextGroupComponent, TranslatePipe],
    template: `
        <app-input-text-group
            [label]="'customizedexports_export_name_label' | translate: 'online' : 'export'"
            [placeholder]="
                'customizedexports_export_name_placeholder' | translate: 'online' : 'export'
            "
            [maxLength]="maxNameLength"
            [formControl]="control()" />
    `,
    styles: `
        app-input-text-group {
            display: block;
            max-width: 34rem;
        }
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NameStepComponent {
    readonly control = input.required<FormControl<string | null>>();

    protected readonly maxNameLength = maxSavedExportNameLength;
}
